import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Firestore, doc, getDoc} from '@angular/fire/firestore';
import {UtilisateurModel} from '../../models/utilisateur';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(
    private router: Router, private db: Firestore, private snackBar: MatSnackBar
  ) {
  }

  async login(identifiant, motDePasse) {
    const datas = await this.getUtilisateur(identifiant);
    if (datas && datas.motDePasse === motDePasse && datas.role === 'administrateur') {
        this.loggedIn.next(true);
        this.router.navigate(['/projets']);
    } else {
      this.message('Identifiants incorrects !');
    }
  }

  async getUtilisateur(id: string): Promise<UtilisateurModel | null> {
    const userRef = doc(this.db, `utilisateurs/${id}`);
    const snap = await getDoc(userRef);
    if (!snap.exists()) {
      return null;
    }
    return {id: snap.id, ...(snap.data() as UtilisateurModel)};
  }

  logout() {
    localStorage.setItem('identifiant', '');
    localStorage.setItem('motDePasse', '');

    localStorage.setItem('resterConnecte', 'false');

    this.loggedIn.next(false);
    this.router.navigate(['/connexion']);
  }

  message(message, duration = 3000) {
    this.snackBar.open(message, null, {duration});
  }
}
